export const ASSETS_ACTIONS = {
  fetch: {
    request: "ASSETS/FETCH_REQUEST",
    success: "ASSETS/FETCH_SUCCESS",
    error: "ASSETS/FETCH_ERROR"
  },
  reset: "ASSETS/RESET"
};
